import { FC, memo } from 'react'
import {
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalOverlay,
  Heading,
  ModalCloseButton,
  Box,
} from '@chakra-ui/react'

import RangerCalendars from './component/RangerCalendars'
import DateHourInputs from './component/DateHourInputs'
import ActionsButtons from './component/ActionsButtons'
import { useCalendarFilters } from './contexts/CalendarFiltersManager/Provider'
import DateIntervalShortcut from './component/DateIntervalShortcut'
import SelectDataFilterType from './component/SelectDataFilterType'
import SingleCalendar from './component/SingleCalendar'
import { callbackOnPressKey } from 'utils/events'

type Props = {
  trigger: JSX.Element
}

const RangerCalendarComponent: FC<Props> = ({ trigger }) => {
  const { isOpen, onClose, onOpen, modalTitle, dateFilterType } = useCalendarFilters()

  return (
    <>
      <Box tabIndex={0} className="accessible" onClick={onOpen} onKeyUp={(event) => callbackOnPressKey(event, onOpen)}>
        {trigger}
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} blockScrollOnMount={false}>
        <ModalOverlay />

        <ModalContent height="auto !important" minWidth="max-content" maxWidth="95px">
          <ModalHeader roundedTop="lg">
            <ModalCloseButton />

            <Heading size={{ base: 'sm', md: 'md' }}>{modalTitle}</Heading>
          </ModalHeader>

          <ModalBody p={0}>
            <Flex direction="column" align="center" p={2}>
              <SelectDataFilterType />
              <DateIntervalShortcut />
              {dateFilterType === 'Intervalo de datas' ? <RangerCalendars /> : <SingleCalendar />}
              <DateHourInputs />
            </Flex>
          </ModalBody>

          <ModalFooter roundedBottom="lg">
            <ActionsButtons />
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default memo(RangerCalendarComponent)
